/** Admin portal public logo assets (apps/admin-portal/public/) */
/** White / light-colored mark for dark UI backgrounds */
export const EUROASIANN_LOGO_DARK = '/euroasiann-logo-dark.png';
/** Navy / dark-colored mark for light UI backgrounds */
export const EUROASIANN_LOGO_LIGHT = '/euroasiann-logo-light.png';
/** Brand mark used on offer letterheads / preview (user-provided Euroasiann logo) */
export const EUROASIANN_OFFER_LOGO = '/euroasiann-offer-logo.png';
/** White-background PDFs / print — offer PDFs use the Euroasiann offer mark. */
export const EUROASIANN_LOGO_PDF = EUROASIANN_OFFER_LOGO;

export const EUROASIANN_GROUP_NAME = 'Euroasiann Group';
export const EUROASIANN_TAGLINE = 'optimizing fleet efficiency through smart procurement';
export const EUROASIANN_OFFICE_ADDRESS =
  'Mastermind-1, Royal Palms Estate, Goregaon East, Mumbai, 400065';
